import {
  ResponseCreation,
  ResponseCreationContentStudio,
  CreationType,
} from '@ads/front-core/api'

export function isBannerStudio(
  content: ResponseCreation['content'],
  creationType: CreationType,
): boolean {
  if (creationType === 'STUDIO') {
    const contentStudio = content as ResponseCreationContentStudio
    return (
      contentStudio?.parts?.length === 1 &&
      contentStudio.parts[0].type === 'IMAGE'
    )
  }
  return false
}
